// ------------------------------------
// props 輸入需求 :
// props.hide : function( void )                    ( 開關按鈕 )
// ------------------------------------


import React, { useEffect} from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import common_images from '../../../comm_imgs';
import { SET_PAGE, SET_PAGENAME } from '../../../stores/reducer_HistoryPage';

const RESNavBar =(props)=>{
    const [t] = useTranslation()
    const dispatch = useDispatch()

    useEffect(()=>{
        dispatch(SET_PAGENAME({pageNameList:props.pageName, index:props.pageDefault}))
        dispatch(SET_PAGE(props.pageDefault))
    }, [])
    const store = useSelector(state=>state.store_hisPage);

    return(
        <div className="h-15 font-m fx-d-r">
            <div className="fx-6 font-xl fx-fsc">
                {t('RESIDENTS_SETTING.RESIDENT_SETTING')}
            </div>
            <div className="fx-2"></div>
            <div className={`fx-2 fx-ccc`}></div>
            <div className={`fx-2 fx-ccc`}></div>
            {props.isShow.map((isShow, index) => isShow?null:<div className="fx-2" key={index}></div>)}

            {props.isShow[0]?
                <div className={`fx-2 fx-ccc his-option ${store.pageActive[0]? "activate":""}`}
                    onClick={()=>{dispatch(SET_PAGE(0))}} id="info">
                    <img src={common_images.INFO} alt="info" />
                    {t('RESIDENTS_SETTING.PERSONAL_INFO')}
                </div>
            :null}
            {props.isShow[1]?
                <div className={`fx-2 fx-ccc his-option ${store.pageActive[1]? "activate":""}`}
                    onClick={()=>{dispatch(SET_PAGE(1))}} id="sensorSetting">
                    <img src={common_images.SENSOR_SETTING} alt="sensorSetting" />
                    {t('RESIDENTS_SETTING.CARE_SETTING')}
                </div>
            :null}
            {props.isShow[2]?
                <div className={`fx-2 fx-ccc his-option ${store.pageActive[2]? "activate":""}`}
                    onClick={()=>{dispatch(SET_PAGE(2))}} id="autoParamsSetting">
                    <img src={common_images.AUTO_PARAMS_SETTING} alt="autoParamsSetting" />
                    {t('RESIDENTS_SETTING.AUTO_SETTING')}
                </div>
            :null}

            <div className="fx-2 fx-nfen" onClick={props.hide}>
                {/* <div className="cross fx-ccc cursor pt"></div> */}
                <div className="cross dark fx-ccc cursor pt"></div>
            </div>
        </div>
    );

}
export default RESNavBar;